import { useMemo } from 'preact/hooks'
import { checkConditions } from '@/components/helpers/metaobjects'
import { globalState } from '@/components/helpers/utils'
import { Criteria } from '@/components/helpers/metaobjects.types'

/**
 * Takes a criteria object to pass to checkConditions to validate what badges should display.
 */

export function useBadges(criteria: Criteria) {
  return useMemo(() => {
    const data = globalState.metaobjects.badges
    return data
      .filter((badge) => checkConditions(badge, criteria))
      .sort((a, b) => a.priority - b.priority)
  }, [criteria])
}
